import { defineCopy } from "@tami/core/intl";

import { NOTES_SCRIPT_COPY_EN_US } from "./en-us/notes-script.copy";
import { NOTES_SCRIPT_COPY_ES_ES } from "./es-es/notes-script.copy";

export const NOTES_SCRIPT_COPY_PT_BR = {
  notesIntro: {
    narrative:
      "A ideia chega no ônibus, no banho, no meio da gravação. As Notas são onde ela para de sumir.",
  },
  notesToolbar: {
    narrative:
      "Escreveu e acabou: sem pasta, sem título obrigatório, sem escolher onde salvar.",
    callout:
      "\"Pensou em algo?\" — um clique e a nota já está aberta.",
  },
  notesList: {
    narrative:
      "Cada nota tem uma cor fixa, então você reconhece a que procura antes de ler o título.",
    callout:
      "Fixe no topo o que está em uso e o resto desce sozinho.",
  },
  notesOverview: {
    narrative:
      "Rascunho de roteiro, gancho de reels, briefing da marca — tudo no mesmo lugar.",
  },
  notesEditor: {
    narrative:
      "O editor salva sozinho enquanto você escreve. Não existe botão de salvar para esquecer.",
    callout:
      "A primeira linha vira o título, e o resto é só escrever.",
  },
} as const;

export const NOTES_SCRIPT_COPY = defineCopy(NOTES_SCRIPT_COPY_PT_BR, {
  "en-US": NOTES_SCRIPT_COPY_EN_US,
  "es-ES": NOTES_SCRIPT_COPY_ES_ES,
});
